import styled from '@emotion/styled';
import { Layout } from '../../../../../components/style';

export const NavigationIconsScroll = styled.div`
  overflow-y: auto;
  width: 100%;
  padding-left: ${Layout.Spacing._2XS};
`;
